<!--
 * @Description: 项目管理
 * @Version: 1.0
 * @Autor: MarkLin
 * @Date: 2022-08-19 18:57:31
 * @LastEditors: MarkLin
 * @LastEditTime: 2022-08-30 17:29:47
-->

<template>
  <div class="container_cm">
    <div class="main_cm">
      <div class="bh_cm">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/guidance' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资料管理</el-breadcrumb-item>
          <el-breadcrumb-item>项目管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="top_cm">
        <div>
          <span>项目名称</span>
          <el-input maxlength="50" v-model="searchForm.projectName" clearable placeholder="请输入项目名称"></el-input>
        </div>
        <div>
          <el-button class="mybtny" v-waves icon="el-icon-search" @click="toSearch">搜索</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
          <el-button class="mybtny" v-waves icon="el-icon-edit" @click="addProject">新增</el-button>
        </div>
      </div>
      <div class="table_cm">
        <Table ref="multipleTable" v-loading="loading" :tableData="List" :pageSize='pageSize' :currentPage="pageIndex" :cloumns="cloumns" :totalNum="total" :pageFlag='true' :selection='false' @handleCurrentChange="handleCurrentChange">
          <el-table-column label="项目名称">
            <template slot-scope="scope">
              <div class="table_first">{{ scope.row.projectName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="manageUnit" label="委托单位" align="center">
          </el-table-column>
          <el-table-column prop="exNumber" label="项目编号" align="center" width="220">
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" align="center" width="220">
          </el-table-column>
          <el-table-column label="同步时间" prop="sycTime" align="center" width="220">
          </el-table-column>
          <el-table-column label="记录" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="exportInfo(scope.row)">出入库记录</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" @click.native.prevent="editClick(scope.row)">编辑</el-button>
              <el-button type="text" @click.native.prevent="stop(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </Table>
      </div>
    </div>
    <!-- 新增项目 -->
    <div>
      <el-dialog title="新增项目" center :visible.sync="addVisible" width="700px" v-if="addVisible" :close-on-click-modal="false">
        <addProject @cancel="cancel" @submit="submit"></addProject>
      </el-dialog>
    </div>
    <!-- 编辑项目 -->
    <div>
      <el-dialog v-if="editVisible" :class="{'slip_out_animation': editVisible,'slip_in_animation': !editVisible}" title="项目编辑" center :visible.sync="editVisible" width="700px" :close-on-click-modal="false">
        <editProject @getHistoryProject="getHistoryProject" @cancel="cancelEdit" @submit="submit" :editData='editData'></editProject>
      </el-dialog>
    </div>
    <!-- 导出弹框 -->
    <el-dialog title="" center :visible.sync="exPosp" width="1500px" v-if="exPosp" append-to-body>
      <exportModel :project-id="projectId" ></exportModel>
    </el-dialog>
    <!-- 历史项目弹框   -->
    <div class="history">
      <el-dialog class="hide-header" v-if="historyProjectVisible" :class="{'slip_in_animation': historyProjectVisible,'slip_out_animation': !historyProjectVisible}" :visible.sync="historyProjectVisible" width="700px" :showClose="false" >
        <history-project @getBackEdit="getBackEdit" :historyProjectDetail="historyProjectDetail" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getProject,
  createProject,
  delProject,
  updateProject,
  getExd,
  importProject
} from "@/api/dataMana.js";
import addProject from "./components/addProject";
import editProject from "./components/editProject";
import Table from "@/components/myTable";
import exportModel from "./components/exportModel";
import historyProject from "@/views/Datamanagement/components/historyProject.vue";
export default {
  inject: ["reload"],
  components: {
    addProject,
    editProject,
    Table,
    exportModel,
    historyProject,
  },
  data() {
    return {
      userInfo: "",
      List: [],
      cloumns: [],
      loading: false,
      pageIndex: 1, //默认当前页
      pageSize: 10, //每页显示数量
      total: 0, //总条数
      searchForm: {},
      addVisible: false, //新增项目弹窗
      editVisible: false, //编辑项目弹窗
      editData: "", //待编辑项目数据
      exPosp: "", //出入库记录弹窗
      projectId: 0,

      historyProjectVisible: false, //历史项目弹框
      historyProjectDetail:{},
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
  },
  mounted() {
    this.getProList();
  },
  methods: {
    //第三方系统同步项目
    importProject(){
      let params={
        projectName:this.editData.projectName,
        manageUnit:this.editData.manageUnit,
        exNumber:this.editData.exNumber,
        exProjectId:this.editData.id,
      }
      importProject(params).then((res) => {
        if (res.code == "200") {
          console.log("success")
        } else {
          this.$message.error(res.msg || "服务器连接失败");
        }
      }).catch((err) => {
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    // 获取项目列表
    getProList() {
      let params = {
        deptId: this.userInfo.deptId,
        current: this.pageIndex,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.loading = true;
      getProject(params)
        .then((res) => {
          if (res.code == "200") {
            this.List = res.data.records;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg || "服务器连接失败");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.msg || err.message || "服务器连接失败");
        });
    },
    toSearch() {
      this.pageIndex = 1;
      this.getProList();
    },
    reset() {
      this.searchForm.projectName = "";
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getProList();
    },
    // 刷新
    refresh() {
      this.reload();
    },
    // 新增项目
    addProject() {
      this.addVisible = true;
    },
    // 编辑项目
    editClick(row) {
      let { projectName, exNumber, manageUnit, id, deptId } = row;
      this.editData = {
        projectName,
        manageUnit,
        exNumber,
        id,
      };
      this.editVisible = true;
    },
    getHistoryProject(e){
      this.editVisible = false;
      this.historyProjectVisible = true;
      this.historyProjectDetail = e
    },
    getBackEdit(e){
      this.editData = e;
      this.historyProjectVisible = false;
      this.editVisible = true;
    },
    // 新增/编辑项目提交
    submit(data, isAdd) {
      if (isAdd) {
        let params = {
          deptid: this.userInfo.deptId,
          deptname: this.userInfo.deptName,
          ...data,
        };
        createProject(params).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "新增成功！");
            this.cancel();
            this.getProList();
          } else {
            this.$message.error(res.msg || "新增失败！");
          }
        });
      } else {
        updateProject({
          deptid: this.userInfo.deptId,
          deptname: this.userInfo.deptName,
          ...data,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.success(res.msg || "更新成功！");
            //this.importProject();
            this.cancelEdit();
            this.getProList();
          } else {
            this.$message.error(res.msg || "更新失败！");
          }
        });
      }
    },
    // 新增取消
    cancel() {
      this.addVisible = false;
    },
    // 编辑取消
    cancelEdit() {
      this.editVisible = false;
    },
    // 停用
    stop(row) {
      this.$confirm("确定删除该项目吗?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delProject(row.id).then((res) => {
            if (res.code == "200") {
              this.$message.success(res.msg || "删除成功！");
              if (this.List.length == 1 && this.pageIndex != 1) {
                this.pageIndex -= 1;
                this.total -= 1;
              }
              this.getProList();
            } else {
              this.$message.error(res.msg || "删除失败！");
            }
          });
        })
        .catch(() => {});
    },
    // 导出记录
    ecportClick(row) {
      getExd({ projId: row.id }).then((res) => {
        if (res.code == "200") {
          let data = res.data;
          window.open(data);
        } else {
          return this.$message("暂无记录");
        }
      });
    },
    // 出入库记录
    exportInfo(row) {
      let self = this;
      self.exPosp = true;
      self.projectId = row.id;

    },
  },
};
</script>

<style lang="less" scoped>

/*滑出*/

.slip_in_animation{ animation: slip_in 1s }

.slip_out_animation{ animation: slip_out 1s }

/*右侧滑入*/
@keyframes slip_in
{
  from {transform:translateX(18%);}
  to {transform:translateX(0);}
}

/*左侧滑出*/
@keyframes slip_out
{
  from {transform:translateX(-18%);}
  to {transform:translateX(0);}
}

.hide-header /deep/ .el-dialog__header {
  display: none;
}


.container_cm {
  width: 100%;
  height: calc(100% - 30px);
  padding: 15px 0;
  .main_cm {
    height: calc(100% - 82px);
    margin: 0 auto;
    .bh_cm {
      height: 20px;
      line-height: 20px;
    }
    .top_cm {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 200px;
        margin: 0 20px;
      }
      .el-button {
        width: 140px;
        margin-left: 20px;
      }
      .el-select {
        margin: 0 20px;
      }
    }
    .table_cm {
      height: 100%;
      .el-button {
        margin: 0 10px;
      }
      /deep/.table_first {
        padding: 0 25px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Datamanagement/index.vue